import { GoalType } from '@griply/types';
import { useCallback } from 'react';
import { Goal } from 'shared/types/goal';

import { useUpdateGoal } from './use-update-goal';

// Flips a goal between goal and project. Only the `type` changes — metric,
// tasks, sub-goals and every other field are preserved, so converting back
// restores the original goal behaviour.
export const useConvertGoalType = () => {
  const { submit } = useUpdateGoal();

  return useCallback(
    (goal: Goal) => {
      const type =
        goal.type === GoalType.Project ? GoalType.Goal : GoalType.Project;
      submit({ id: goal.id, type });
    },
    [submit],
  );
};
